import { Col } from 'antd'

import { EpidemiologyCaseForm058E_SymptomsSection } from 'src/api/requests'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

type Props = {
  symptoms: EpidemiologyCaseForm058E_SymptomsSection
}

export const PainsSymptomsDetailsCard = ({ symptoms }: Props) => {
  const { t } = useLocales()

  const abdominalPainLabel = t('epidemiology.symptoms.pains.abdominalPain')

  return (
    <>
      <Col span={24}>
        <Text>
          {`8. ${t('epidemiology.pains')}`}:{' '}
          <Text weight={400}>
            {t(`epidemiology.symptoms.general.${symptoms.pains?.status}`)}
          </Text>
        </Text>
      </Col>

      {symptoms.pains?.status === 'yes' && (
        <>
          {symptoms.pains.headache?.isSelected && (
            <Col span={8}>
              <Text>{t('epidemiology.symptoms.pains.headache')}</Text>
            </Col>
          )}

          {symptoms.pains.jointPain?.isSelected && (
            <Col span={8}>
              <Text>{t('epidemiology.symptoms.pains.jointPain')}</Text>
            </Col>
          )}

          {symptoms.pains.musclePain?.isSelected && (
            <Col span={8}>
              <Text>{t('epidemiology.symptoms.pains.musclePain')}</Text>
            </Col>
          )}

          {symptoms.pains.abdominalPain?.isSelected && (
            <>
              <Col span={8}>
                <Text>{abdominalPainLabel}</Text>
              </Col>

              {symptoms.pains.abdominalPain.rightHypochondriumPain
                ?.isSelected && (
                <Col span={8}>
                  <Text>
                    {abdominalPainLabel} -{' '}
                    {t('epidemiology.symptoms.pains.rightHypochondriumPain')}
                  </Text>
                </Col>
              )}

              {symptoms.pains.abdominalPain.epigastricPain?.isSelected && (
                <Col span={8}>
                  <Text>
                    {abdominalPainLabel} -{' '}
                    {t('epidemiology.symptoms.pains.epigastricPain')}
                  </Text>
                </Col>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}
